import {reportNonBizData} from "./mNonBizReport";


export const presetBtPlayFirstShow = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstShow', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstClick = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstClick', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogShow = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogShow', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogClick = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogClick', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogCloseManual = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogCloseManual', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogCloseAuto = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogCloseAuto', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstClose = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstClose', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstEndcardShowFailed = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstEndcardShowFailed', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstWebviewTerminate = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstWebviewTerminate', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstInitSDKVersionEmpty = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstInitSDKVersionEmpty', dataCustomized: {}}
    },
    action: reportNonBizData
}